// @flow
import React, { Component, Fragment } from 'react';
import SearchBox from 'components/search/SearchBox';
import { SearchActions } from 'store/actionCreators';
import { type State } from 'store';
import { connect } from 'react-redux';
import { type ContextRouter, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

type Props = {
  currentKeyword: ?string,
  currentMenu: ?string,
} & ContextRouter;

class SearchBoxContainer extends Component<Props> {
  onSearch = (keyword: string, menu: string) => {
    const { currentKeyword, currentMenu, history } = this.props;
    if (currentKeyword === keyword && currentMenu === menu) return null;
    if (!keyword) {
      // SearchActions.initialize();
      return null;
    }
    // SearchActions.initialize();
    const q = keyword
      .replace(/&/g,"%26")
      .replace(/\+/g,"%2B");
    history.push(`/search?q=${q}&menu=products`);
    return SearchActions.publicSearch({
      q,
      menu,
    });
  };

  render() {
    const { currentKeyword, currentMenu } = this.props;
    const title = currentKeyword ? `${currentKeyword} | 캐시바이 검색` : '캐시바이 검색';
    return (
      <Fragment>
        <Helmet>
          <title>{title}</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <SearchBox onSearch={this.onSearch} currentMenu={currentMenu} />
      </Fragment>
    );
  }
}

export default connect((state: State) => ({
  currentKeyword: state.search.currentKeyword,
  currentMenu: state.search.currentMenu,
}))(withRouter(SearchBoxContainer));



// WEBPACK FOOTER //
// ./src/containers/search/SearchBoxContainer.js